module.exports = __webpack_public_path__ + "img/KUCE-01.a73bdd37.png";